<template>
    <div>
        <v-select
            v-model="selected"
            :options="options"
            :reduce="opt => opt.id"
            label="label"
            :placeholder="'Default (' + defaultModel + ')'"
            :clearable="true"
            :searchable="true"
            :filterable="true"
            class="model-select"
        >
            <template #option="opt">
                <div class="model-option-row">
                    <span class="model-option-name">{{ opt.name }}</span>
                    <span class="model-option-id">{{ opt.id }}</span>
                </div>
            </template>
            <template #selected-option="opt">
                <span>{{ opt.name }}</span>
            </template>
            <template #no-options>
                No models available
            </template>
        </v-select>
        <input type="hidden" :name="name" :value="selected || ''">
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        models: {
            type: Array,
            default: () => []
        },
        value: {
            type: String,
            default: ''
        },
        defaultModel: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            selected: this.value || null
        };
    },
    computed: {
        options() {
            return this.models.map(m => ({
                id: m.id,
                name: m.name,
                label: m.name + ' (' + m.id + ')'
            }));
        }
    }
};
</script>

<style>
.model-select .vs__dropdown-toggle {
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 2px 8px;
    font-size: 13px;
    min-height: 34px;
    background: #fff;
}
.model-select .vs__dropdown-toggle:hover {
    border-color: #a5b4fc;
}
.model-select .vs__search {
    font-size: 13px;
    padding: 2px 0;
}
.model-select .vs__search::placeholder {
    color: #9ca3af;
    font-size: 12px;
}
.model-select .vs__dropdown-menu {
    font-size: 13px;
    max-height: 280px;
    border-color: #e5e7eb;
    box-shadow: 0 10px 25px -5px rgba(0,0,0,0.1);
    border-radius: 6px;
    z-index: 9999;
}
.model-select .vs__dropdown-option {
    padding: 6px 10px;
}
.model-select .vs__dropdown-option--highlight {
    background: #eef2ff;
    color: #4338ca;
}
.model-select .vs__selected {
    font-size: 13px;
    margin: 2px 4px 2px 0;
    padding: 0;
    border: none;
    font-family: ui-monospace, SFMono-Regular, monospace;
}
.model-select .vs__clear {
    margin-right: 4px;
}
.model-option-row {
    display: flex;
    flex-direction: column;
    gap: 1px;
}
.model-option-name {
    font-weight: 500;
}
.model-option-id {
    font-size: 11px;
    color: #9ca3af;
    font-family: ui-monospace, SFMono-Regular, monospace;
}
.vs__dropdown-option--highlight .model-option-id {
    color: #818cf8;
}
</style>
